//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
// import fileDownload from "js-file-download" ;
import ProductTable from "@/pages/PendingValidations/components/ProductTable.vue";
import ProductForm from "@/pages/PendingValidations/components/ProductForm.vue";
import StoreTable from "@/pages/PendingValidations/components/StoreTable.vue";
import StoreForm from "@/pages/PendingValidations/components/StoreForm.vue";
import WarehouseTable from "@/pages/PendingValidations/components/WarehouseTable.vue";
import WarehouseForm from "@/pages/PendingValidations/components/WarehouseForm.vue";
import { Feedback } from "@/utils/notify-toaster.js";

export default {
  name: "ProductManagement",
  components: {
    ProductTable,
    ProductForm,
    StoreTable,
    StoreForm,
    WarehouseTable,
    WarehouseForm,
  },
  mounted: async function () {
    this.isLoading = true;
    let response = await BackendServices.getPendingValidations("products", {
      page: 1,
      rowsPerPage: 10,
    });
    this.recordsTotal = response.data.meta.total_count;
    this.productsList = response.data.data;
    this.isLoading = false;
  },
  data: () => ({
    productForm: true,
    storeForm: true,
    warehouseForm: true,
    productsList: [],
    storesList: [],
    warehouseList: [],
    filterState: null,
    tab: "product",
    validationType: null,
    rightSidePane: false,
    product: null,
    store: {},
    warehouse: {},
    isLoading: false,
    recordsTotal: 0,
  }),
  methods: {
    updateStore(event) {
      this.store = event;
    },
    updateProduct(event) {
      this.product = event;
    },
    successMessage: function () {
      this.$q.notify({
        message: "Operação realizada com sucesso.",
        color: "green-9",
      });
    },
    askForProductData: async function (event) {
      this.isLoading = true;
      let response = await BackendServices.getPendingValidations(
        "products",
        event.pagination
      );
      this.recordsTotal = response.data.meta.total_count;
      this.productsList = response.data.data;
      this.isLoading = false;
    },
    askForStoreData: async function (event) {
      this.isLoading = true;
      let response = await BackendServices.getPendingValidations(
        "stores",
        event.pagination
      );
      this.recordsTotal = response.data.meta.total_count;
      this.storesList = response.data.data;
      this.isLoading = false;
    },
    askForWarehouseData: async function (event) {
      this.isLoading = true;
      let response = await BackendServices.getPendingValidations(
        "warehouses",
        event.pagination
      );
      this.recordsTotal = response.data.meta.total_count;
      this.warehouseList = response.data.data;
      this.isLoading = false;
    },
    changeTab: async function (event) {
      this.rightSidePane = false;
      this.product = {};
      this.store = {};
      this.warehouse = {};

      await this.$nextTick();
      if (event === "product") {
        this.askForProductData({ pagination: { page: 1, rowsPerPage: 10 } });
      }
      if (event === "store") {
        this.askForStoreData({ pagination: { page: 1, rowsPerPage: 10 } });
      }
      if (event === "warehouse") {
        this.askForWarehouseData({ pagination: { page: 1, rowsPerPage: 10 } });
      }
    },
    openExistingProduct: function (event) {
      this.rightSidePane = true;
      this.product = event;
      this.traitsForm = true;
      this.logisticsForm = true;
    },
    openExistingStore: function (event) {
      this.rightSidePane = true;
      this.store = event;
    },
    openExistingWarehouse: function (event) {
      this.rightSidePane = true;
      this.warehouse = event;
    },
    closeForm: function () {
      this.rightSidePane = false;
      this.product = {};
      this.store = {};
      this.warehouse = {};
    },
    saveData: async function () {
      let operation = null;

      if (this.tab === "product") {
        if (this.validationType === "new") {
          operation = await BackendServices.updateExistingProduct(this.product);
          if (operation.status === 200) {
            Feedback.success("Produto actualizado.");
            this.closeForm();
            this.askForProductData({
              pagination: { page: 1, rowsPerPage: 10 },
            });
          }
        }

        if (this.validationType === "existing") {
          this.$modal.show("codeConfirmDialog");
          // operation = await BackendServices.createNewProductCode(this.product);
          // if (operation.status === 201) {
          //   Feedback.success("Produto actualizado.");
          // }
        }

        if (this.validationType === "delete") {
          operation = await BackendServices.deleteProductValidation(
            this.product
          );
          if (operation.status === 204) {
            Feedback.success("Produto actualizado.");
            this.closeForm();
            this.askForProductData({
              pagination: { page: 1, rowsPerPage: 10 },
            });
          }
        }

        if (this.validationType === "delete-exclude") {
          operation = await BackendServices.deleteProductValidationExclude(
            this.product
          );
          if (operation.status === 204) {
            Feedback.success("Produto actualizado.");
            this.closeForm();
            this.askForProductData({
              pagination: { page: 1, rowsPerPage: 10 },
            });
          }
        }
      }

      if (this.tab === "store") {
        if (this.validationType === "new") {
          operation = await BackendServices.updateExistingStore(this.store);
          if (operation.status === 200) {
            Feedback.success("Loja actualizada.");
            this.closeForm();
            this.askForStoreData({ pagination: { page: 1, rowsPerPage: 10 } });
          }
        }

        if (this.validationType === "existing") {
          // operation = await BackendServices.createNewStoreCode(this.store);
          // if (operation.status === 201) {
          //   Feedback.success("Loja actualizada.");
          //   this.closeForm();
          // }
          this.$modal.show("codeConfirmDialog");
        }

        if (this.validationType === "delete") {
          operation = await BackendServices.deleteStoreValidation(this.store);
          if (operation.status === 204) {
            Feedback.success("Loja actualizada.");
            this.closeForm();
            this.askForStoreData({
              pagination: { page: 1, rowsPerPage: 10 },
            });
          }
        }

        if (this.validationType === "delete-exclude") {
          operation = await BackendServices.deleteStoreValidationExclude(
            this.store
          );
          if (operation.status === 204) {
            Feedback.success("Loja actualizada.");
            this.closeForm();
            this.askForStoreData({
              pagination: { page: 1, rowsPerPage: 10 },
            });
          }
        }
      }

      if (this.tab === "warehouse") {
        operation = BackendServices.updateExistingWarehouse(this.warehouse);
      }
    },
    dialogConfirm: async function () {
      let operation = null;
      this.$modal.hide("codeConfirmDialog");
      if (this.validationType === "existing" && this.tab === "product") {
        delete this.product.type;
        operation = await BackendServices.createNewProductCode(this.product);
        if (operation.status === 201) {
          Feedback.success("Produto actualizado.");
          this.closeForm();
          this.askForProductData({ pagination: { page: 1, rowsPerPage: 10 } });
        }
      }
      if (this.validationType === "existing" && this.tab === "store") {
        delete this.store.type;
        operation = await BackendServices.createNewStoreCode(this.store);
        if (operation.status === 201) {
          Feedback.success("Loja actualizada.");
          this.closeForm();
          this.askForStoreData({ pagination: { page: 1, rowsPerPage: 10 } });
        }
      }
    },
    removeProduct: function (product) {
      BackendServices.deleteProduct(product)
        .then(() => window.location.reload())
        .catch((error) =>
          this.$q.notify({ message: error.response.data.error, color: "red" })
        );
    },
    exportFilteredProducts: function () {
      BackendServices.downloadPendingValidationsList(this.tab).then(
        (response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data])
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "PendingValidations_"+this.tab+"_.xlsx"); //any other extension
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      );
    },
  },
  computed: {
    validFormState: function () {
      return this.productForm && this.storeForm && this.warehouseForm;
    },
  },
  watch: {},
};
